module.exports = __webpack_public_path__ + "static/img/card_1_13.0dde8fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_1_13.png
// module id = uEQT
// module chunks = 0